// extracted by mini-css-extract-plugin
var _1 = "country-flag__Nx7yy";
export { _1 as "countryFlag" }
